/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 17:55:13
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-22 17:36:08
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/HotTags/SetHotTags/index.tsx
 */
import React from 'react';

import css from './css.less';

import arrayMove from 'array-move';
import _ from 'lodash';

import { Input, Modal, ModalFooter } from '@/src/components/Antd';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import ImgSkuAndNameLongDisplay from 'src/constrains/ProductDraggableDisplay/ImgSkuAndNameLongDisplay';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';

const SetHotTags = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { visible, data = {}, onCancel, onOk } = props;
  const [hasError, setHasError] = React.useState(false);
  const {
    title: oriTitle,
    products: oriProducts = [],
    index,
    draggableId,
  } = data || {};
  const [products, setProducts] = React.useState(oriProducts || []);
  const [title, setTitle] = React.useState(oriTitle || '');
  const handleOnSort = (from, to) => {
    let _p = _.cloneDeep(products);
    _p = arrayMove(_p, from, to);
    setProducts(_p);
  };
  const handleOnDelete = (index) => {
    const _p = _.cloneDeep(products);
    _p.splice(index, 1);
    setProducts(_p);
  };
  const handleOnOk = () => {
    if (!title || (products || []).length === 0) {
      setHasError(true);
    } else {
      if (onOk) {
        onOk({ draggableId, title, products }, index);
      }
    }
  };
  const handleTitle = (e) => {
    setTitle(e);
    setHasError(false);
  };
  const handleOnProductChange = (prods) => {
    setProducts(prods);
    setHasError(false);
  };
  return (
    <React.Fragment>
      <Modal
        title={getI18n('salesChannelContent.index.setHotTag')}
        visible={visible}
        width={900}
        onCancel={onCancel}>
        <div className={css.container}>
          <ItemWrapper
            title={getI18n('salesChannelContent.index.tag')}
            containerClassName={css.titleContainer}>
            <Input
              maxLength={50}
              size='large'
              value={title}
              onChange={handleTitle}
            />
          </ItemWrapper>
          <ItemWrapper title={getI18n('general.selectProduct')}>
            <ImgSkuAndNameLongDisplay
              onSort={handleOnSort}
              onDelete={handleOnDelete}
              data={products}
              dragContainerClassName={css.dragContainerClassName}
              droppableId={'HotTagsModalDropZones'}
              onChange={handleOnProductChange}
            />
          </ItemWrapper>
        </div>
        <ModalFooter
          okText={getI18nFromGeneral('general.antd.Modal.ModalFooter.confirm')}
          cancelText={getI18nFromGeneral('general.commonHeader.discard_text')}
          okClassName={css.okBtn}
          onOk={handleOnOk}
          onCancel={onCancel}
          {...(hasError
            ? {
                front: (
                  <div className={css.errText}>
                    {getI18n('salesChannelContent.index.setHotTagFrontError')}
                  </div>
                ),
              }
            : {})}
        />
      </Modal>
    </React.Fragment>
  );
};
export default SetHotTags;
